export default __webpack_public_path__ + "static/media/exploreArrows.c4f69057.svg";